module.exports = __webpack_public_path__ + "static/scale-model-of-larimer-square-in-lakewood-colorado-01fd8ce68bf139ccca22350774e8229f.png";